import { render, staticRenderFns } from "./CrystalLogo.vue?vue&type=template&id=5f60ee66&scoped=true"
import script from "./CrystalLogo.vue?vue&type=script&lang=js"
export * from "./CrystalLogo.vue?vue&type=script&lang=js"
import style0 from "./CrystalLogo.vue?vue&type=style&index=0&id=5f60ee66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f60ee66",
  null
  
)

export default component.exports